import { ImageProps } from "../types";

export const SvgIcon = ({ src, width, height }: ImageProps) => (
  <img src={`/img/svg/${src}`} alt={src} width={width} height={height} />
);
